import React from 'react';
import Hidden from '@mui/material/Hidden';
import { useLocation } from 'react-router-dom';
import useLoadNewInvoicesOnMount from '@fingo/lib/hooks/useLoadNewInvoicesOnMount';
import useLoadNewCessionsOnMount from '@fingo/lib/hooks/useLoadNewCessionsOnMount';

import DesktopNavbar from './DesktopNavbar';
import MobileNavbar from './MobileNavbar';
import NO_NAVBAR_ROUTES from '../../../constants/no-navbar-routes';

const WorkspaceNavbar = () => {
  useLoadNewInvoicesOnMount();
  useLoadNewCessionsOnMount();
  const location = useLocation();
  if (NO_NAVBAR_ROUTES.includes(location?.pathname)) return null;
  return (
    <>
      <Hidden mdUp>
        <MobileNavbar />
      </Hidden>
      <Hidden mdDown>
        <DesktopNavbar />
      </Hidden>
    </>
  );
};

export default WorkspaceNavbar;
